/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { MainMap } from 'components/MainMap'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Chart from 'components/Charts_Chart'
import Key from 'components/Charts_Key'
import { Link } from '@ta-interaktiv/contentbricks'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { StandaloneIFrame } from 'components/StandaloneIFrame'

// TODO Set the correct article ID here
import SVG, { Props as SVGProps } from 'react-inlinesvg'

const ARTICLE_ID = '692676608334'
const isMobile = window.innerWidth < 600
export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Worum es im Krieg in der Ukraine geht</h1>
            <h2>
              Russland hat auf breiter Front eine Invasion im Nachbarland
              Ukraine gestartet. Fakten, Hintergründe und Folgen des
              Einmarsches.{' '}
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Zita Affentranger, Sebastian Broschinski, Patrick Vögeli
            </div>
            <div className='ta updated'>Aktualisiert am 23. Februar 2022</div>
          </div>
      
          <h4>Warum herrscht Krieg in der Ukraine?</h4>
          <p className='ta text'>
            Russland hat am frühen Morgen des 24. Februar eine Invasion des
            Landes begonnen. Die Ukraine wurde mit Raketen beschossen, zudem
            rücken russische Verbände von Norden, Osten und Süden vor. Es ist
            bereits von Dutzenden Toten und Zehntausenden Flüchtlingen die Rede.
            Moskau hatte in Grenznähe zur Ukraine seit Dezember 150’000 bis
            190’000 Soldaten zusammengezogen. In Weissrussland, dem engsten
            Verbündeten des Kremls, wurden ebenfalls Einheiten stationiert, es
            ist das Aufmarschgebiet für den Angriff auf die Hauptstadt Kiew. Der
            Kreml behauptet, er komme mit der Intervention seinen Verbündeten in
            der Ostukraine zu Hilfe. Die «Volksrepubliken» Donezk und Luhansk,
            von Kiew abtrünnige Gebiete in der Ostukraine, hätten Russland um
            Hilfe gebeten, sagt Putin. Man habe deshalb eine «militärische
            Spezialoperation» beschlossen. Die Ukraine und Staaten auf der
            ganzen Welt haben den Überfall aufs Schärfste kritisiert.
          </p>
        </div>
      </div>

      <div className='ui text container mainmap'>
        <Chart>
          <AutofitIFrame src='https://datawrapper.dwcdn.net/BVnIX' />
        </Chart>
      </div>

      {/* <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Der russische Truppenaufmarsch ist auch aus dem Weltall zu
              beobachten. Satellitenbilder des US-amerikanischen Unternehmens
              Maxar Technologies, die bereits Ende letzten Jahres aufgenommen
              wurden, zeigen geparkte russische Panzer und Artillerieausrüstung
              an verschiedenen Standorten entlang der ukrainischen Nord-, Ost-
              und Südgrenze.
            </p>
            <p>
              Die folgenden Bilder zeigen drei der zwischen April 2020 und
              November 2021 gebauten, militärischen Einrichtungen:
            </p>
          </div>
        </div>
      </div> */}

      {/* <div className='ui container slider'>
        <Chart
          title='Jelnja'
          source='Foto: Maxar Technologies satellite imagery via Google Earth'
          sub="54°36.6845'N, 33°10.5163'E"
        >
          <img
            className='locatormap'
            src={require('images/icons/icon-jelnja-01.png')}
          />
          <StandaloneIFrame
            id='a'
            url={
              isMobile
                ? 'https://interaktiv.tagesanzeiger.ch/2015/slider/?before=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/yelnya-mobile-vorher.jpg&after=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/yelnya-mobile-nachher.jpg'
                : 'https://interaktiv.tagesanzeiger.ch/2015/slider/?before=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/yelnya-desktop-vorher.jpg&after=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/yelnya-desktop-nachher.jpg'
            }
            initialHeight={550}
          />
        </Chart>
      </div>

      <div className='ui text container slider'>
        <Chart
          title='Waluiki'
          source='Foto: Maxar Technologies satellite imagery via Google Earth'
          sub="50°17.2932'N, 38°0.7483'E"
        >
          {' '}
          <img
            className='locatormap'
            src={require('images/icons/icon-waluiki-01.png')}
          />
          <StandaloneIFrame
            id='b'
            url={
              isMobile
                ? 'https://interaktiv.tagesanzeiger.ch/2015/slider/?before=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/valyuki-mobile-vorher.jpg&after=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/valyuki-mobile-nachher.jpg'
                : 'https://interaktiv.tagesanzeiger.ch/2015/slider/?before=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/valyuki-desktop-vorher.jpg&after=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/valyuki-desktop-nachher.jpg'
            }
            initialHeight={380}
          />
        </Chart>
        <Chart
          title='Klinzy'
          source='Foto: Maxar Technologies satellite imagery via Google Earth'
          sub="52°44.3314'N, 32°1.5994'E"
        >
          <img
            className='locatormap'
            src={require('images/icons/icon-klinzy-01.png')}
          />
          <StandaloneIFrame
            id='b'
            url={
              isMobile
                ? 'https://interaktiv.tagesanzeiger.ch/2015/slider/?before=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/klintsy-mobile-vorher.jpg&after=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/klintsy-mobile-nachher.jpg'
                : 'https://interaktiv.tagesanzeiger.ch/2015/slider/?before=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/klintsy-desktop-vorher.jpg&after=https://interaktiv.tagesanzeiger.ch/2022/russland-ukraine-krise/klintsy-desktop-nachher.jpg'
            }
            initialHeight={380}
          />
        </Chart>
      </div> */}

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <h4>Was will Moskau mit dem Angriff erreichen?</h4>
          <p className='ta text'>
            Russland werde die Ukraine «entmilitarisieren und entnazifizieren»,
            sagt Putin in seiner Kriegsrede an die Nation. Er beschimpft die
            frei gewählte Regierung in Kiew seit Jahren wahlweise als «Junta»
            oder als «Nazis». «Entnazifizierung» bedeutet in seiner Logik
            deshalb, dass er die Führung in Kiew stürzen und durch russlandtreue
            Leute ersetzen will. Darauf deutet auch der rasche militärische
            Vorstoss Richtung Kiew hin. Das zweite Ziel betrifft die Entwaffnung
            der ukrainischen Armee: Putin hat die letzten Monate scharf
            kritisiert, dass der Westen die Ukraine auch mit modernsten Waffen
            aufgerüstet habe, nun spricht er von einer «Entmilitarisierung»:
            Durch den Raketenbeschuss wurden bereits Dutzende
            Militäreinrichtungen zerstört. Am Boden wird Russland nun versuchen,
            die ukrainische Armee möglichst schnell auszuschalten.
          </p>
          <h4>Hat die Ukraine eine Chance gegen den russischen Angriff?</h4>
          <p className='ta text'>
            Die Ukraine kann dem russischen Angriff auf die Dauer nicht
            standhalten. Sie ist zwar sehr viel besser ausgerüstet und trainiert
            als 2014, als Russland die Krim praktisch ohne Widerstand
            annektierte und in der Ostukraine vorstossen konnte. Die Nato und
            vor allem die USA haben der Ukraine geholfen, ihre Schlagkraft zu
            erhöhen mit Waffen, Instruktoren und gemeinsamen Militärübungen.
            Mehrere Mitgliedsländer haben die Waffenlieferungen seit dem
            russischen Aufmarsch massiv erhöht. Dennoch bleibt die moderne und
            riesige russische Armee viel schlagkräftiger. Doch militärische
            Stärke ist nicht alles: Die Ukrainer sind fest entschlossen, ihr
            Land zu verteidigen, Kiew hat eine Generalmobilmachung verkündet,
            jeder, der eine Waffe tragen kann, soll dies auch tun. Damit sind
            viele Opfer auf der ukrainischen Seite zu befürchten. Russland muss
            mit einem erbitterten Kampf auch aus dem Untergrund rechnen.
          </p>
          <h4>Greift Putin in der ganzen Ukraine an oder nur im Osten?</h4>
          <p className='ta text'>
            Die Angriffe betreffen die ganze Ukraine. Zu Beginn der Invasion hat
            Russland Ziele überall im Land mit Raketen beschossen. Im Visier
            waren vor allem militärische Einrichtungen, zum Beispiel Flugplätze,
            es wurden aber auch zivile Einrichtungen getroffen. Der Vorstoss am
            Boden richtet sich von Norden her vor allem gegen die Hauptstadt
            Kiew. Heftige Kämpfe gibt es zudem im Osten des Landes um die Städte
            Mariupol und Charkiw. Beschossen wird auch der Süden entlang des
            Schwarzen Meeres. Ein Vorstoss Richtung Westen, um das ganze Land zu
            besetzen, lässt sich bisher nicht ausmachen.
          </p>
          <h4>Wie gross ist die Gefahr einer nuklearen Eskalation?</h4>
          <p className='ta text'>
            Putin hat in seiner Kriegsrede ultimativ davor gewarnt, Russland
            anzugreifen. «Wir sind zu allem bereit, alle Entscheide sind
            getroffen», erklärte er mit scharfer Stimme. «Russland ist einer der
            mächtigsten Nuklearstaaten», drohte er, und verfüge auch sonst über
            zahlreiche Hightechwaffen. «In diesem Sinne sollte niemand den
            geringsten Zweifel daran haben, dass jeder potenzielle Aggressor
            besiegt wird.» Die Drohung richtet sich gegen den Westen,
            insbesondere natürlich gegen die USA. Präsident Joe Biden hat
            klargemacht, dass er nicht militärisch eingreifen und keine Soldaten
            in die Ukraine schicken werde. So gesehen ist die Gefahr einer
            nuklearen Eskalation klein.
          </p>
          <h4>Sind weitere Länder von einem russischen Angriff bedroht?</h4>
          <p className='ta text'>
            US-Präsident Joe Biden warnt, Putins Ambitionen gingen über die
            Ukraine hinaus. Er wolle die alte Sowjetunion wiederherstellen. Im
            Westen wären gemäss dieser Theorie neben der Ukraine auch
            Weissrussland und die baltischen Staaten in Gefahr. Weissrussland
            ist ein enger Verbündeter Moskaus und gehört bereits heute einer
            Union mit Russland an. Ein anderer Fall sind die drei baltischen
            Staaten Lettland, Estland und Litauen, denen Putin immer wieder mehr
            oder weniger offen gedroht hat. Die Länder gehören aber der Nato an
            und werden anders als die Ukraine im Kriegsfall von den Verbündeten
            verteidigt. Ein russischer Angriff würde hier also den
            Kriegseintritt vieler westlicher Staaten und der USA nach sich
            ziehen. Das wäre eine massive Eskalation und würde neben dem Krieg
            in der Ukraine die militärischen Möglichkeiten Russlands wohl
            übersteigen.
          </p>

          <h4>
            Verhängt der Westen jetzt die angedrohten, massiven Sanktionen?
          </h4>
          <p className='ta text'>
            Deutschland hat als Erstes die fertig gebaute Gas-Pipeline Nord
            Stream 2 auf Eis gelegt, die demnächst Gas direkt von Russland nach
            Deutschland bringen sollte. Es wurden neu viele Russen auf die
            schwarze Liste gesetzt, unter ihnen auch der Verteidigungsminister
            und der Generalstabschef. Gegen russische Banken wurden Sanktionen
            verhängt, und der Gebrauch des Dollar, der im russischen
            Wirtschaftssystem noch immer eine wichtige Rolle spielt, wird
            erschwert. Auch die russischen Oligarchen sind im Visier. Doch die
            ganz scharfen Massnahmen wurde noch ausgespart: Die USA und
            Grossbritannien hatten vor der Invasion davon gesprochen, Russlands
            Präsidenten und seine Familie persönlich auf die Sanktionsliste zu
            setzen, was ein massiver politischer Affront wäre. Auch die
            Abkopplung Russlands vom internationalen Zahlungsverkehrssystem
            Swift hat bisher nicht stattgefunden.
          </p>

          <h4>Was will Russland eigentlich von der Ukraine?</h4>
          <p className='ta text'>
            Russland will eine Ukraine mit beschränkter Souveränität und in der
            ukrainischen Innenpolitik mitreden. Dafür wurden in Kiew früher
            russlandfreundliche Spitzenpolitiker aufgebaut. 2004 brach die
            sogenannte orange Revolution aus, ein Volksaufstand gegen
            Wahlfälschungen, die dem Kandidaten Moskaus den Sieg gegen einen
            prowestlichen Reformer sichern sollten. Wochenlang gingen
            Hunderttausende Menschen auf die Strasse und entschieden den
            Machtkampf schliesslich für sich. Doch 2014 war man praktisch wieder
            gleich weit: Der von Russland beeinflusste Präsident Wiktor
            Janukowitsch wollte die geplante Westintegration beenden, was
            wiederum grosse und diesmal auch extrem gewalttätige Demonstrationen
            zur Folge hatte. Schliesslich flüchtete Janukowitsch nach Russland,
            und in Kiew wurde eine prowestliche Regierung installiert und später
            in Wahlen bestätigt.
          </p>
          <h4>Was ist das Problem mit der Krim?</h4>
          <p className='ta text'>
            In all den Wirren hat Russland die Chance genutzt, die ukrainische
            Halbinsel Krim zu besetzen und zu annektieren. Das geschah praktisch
            über Nacht, ohne dass ein einziger Schuss abgefeuert wurde. In
            Russland, aber auch bei den vielen ethnischen Russen auf der Krim,
            stiess die Annexion auf begeisterte Zustimmung. Die Halbinsel hatte
            seit 1783 zu Russland gehört, 1954 wurde die Krim im Rahmen von
            Festivitäten der ukrainischen Sowjetrepublik zugeschlagen. Damals
            hatte das in der Realität keinerlei Auswirkungen, doch nach dem
            Untergang der Sowjetunion 1991 war die Krim dann völkerrechtlich
            Teil der Ukraine. Die russische Führung hat das akzeptiert und die
            Grenzen der Ukraine in internationalen Verträgen abgesegnet. Kein
            westliches Land anerkennt heute die völkerrechtswidrige Annexion der
            Krim. Europäer und Amerikaner verhängten wirtschaftliche
            Strafmassnahmen gegen Russland, die Beziehungen sind seither auch
            politisch zerrüttet. Die Ukraine pocht darauf, dass das strategisch
            wichtige Gebiet an sie zurückgeht, was in absehbarer Zeit aber nicht
            passieren dürfte.
          </p>
          <h4>Was ist im Osten der Ukraine los?</h4>
          <p className='ta text'>
            Am 21. Februar hat Präsident Wladimir Putin der russischen Nation
            erklärt, dass er die von der Ukraine abtrünnigen Gebiete um die
            Städte Luhansk und Donezk als unabhängig anerkennen werde, weil die
            Ukraine nicht an einer friedlichen Lösung für die Ostukraine
            interessiert sei. Er schloss mit den beiden Gebieten ein
            Sicherheitsabkommen und drohte Kiew, wenn die ukrainische Armee die
            Gefechte an der Waffenstillstandslinie nicht beende, werde dies
            Konsequenzen haben. Noch am gleichen Abend kündigte er die
            Entsendung von Soldaten an, die er als «Friedenstruppen»
            bezeichnete. Ein geltendes, aber nicht umgesetztes Friedensabkommen
            hat Moskau für hinfällig erklärt. Über 13’000 Menschen wurden in dem
            Konflikt bisher getötet.
          </p>
          <h4>Warum haben sich die Gebiete von Kiew abgespalten?</h4>
          <p className='ta text'>
            Nach der Annexion der ukrainischen Halbinsel Krim hat es in der
            Ostukraine einen Krieg gegeben. Von Russland unterstützte Rebellen
            haben sich 2014 gegen die neue, westlich orientierte Regierung in
            Kiew aufgelehnt, die nach den wochenlangen, auch gewalttätigen
            Demonstrationen an die Macht kam. Die Rebellengebiete um die Städte
            Luhansk und Donezk, die sich traditionell eher nach Russland
            orientieren, wurden vom Kreml acht Jahre lang künstlich am Leben
            erhalten: militärisch, wirtschaftlich und politisch. Das verschafft
            Moskau Druckmöglichkeiten auf die unabhängige Ukraine. Heute steht
            die russische Armee in den Regionen, die Moskau angeblich vor der
            Ukraine retten musste.
          </p>
          <h4>Was will Russland von der Nato?</h4>
          <p className='ta text'>
            Präsident Wladimir{' '}
            <Link href='347254207221'>
              Putin verlangt von der Nato schriftliche Sicherheitsgarantien
            </Link>{' '}
            und hat dafür einen Vertrag mit Forderungen vorgelegt. Darin sollte
            sich die Nato schriftlich und rechtlich verbindlich verpflichten,
            die Allianz nicht mehr weiter auszudehnen. Zudem dürfe die Nato
            keine «militärischen Aktivitäten» auf dem Territorium der Ukraine
            oder in «anderen Staaten Osteuropas, im Südkaukasus und
            Zentralasien» durchführen. Und die Nato soll keine «Truppen und
            Waffen auf das Territorium eines anderen europäischen Landes»
            verlegen, was sich erneut gegen die Ukraine richtet, die vom Westen
            mit Waffen versorgt wird. Und schliesslich soll die Nato ihre
            Truppen hinter ihre Grenzen von 1997 zurückziehen, was die
            Nato-Osterweiterung faktisch ungeschehen machen würde. Die Nato hat
            die Forderungen schriftlich klar zurückgewiesen. Putin reagierte
            scharf: Der Westen missachte die russischen Sicherheitsbedenken seit
            30 Jahren, im Fall der Ukraine seien aber alle «roten Linien»
            überschritten worden.
          </p>
          <Chart
              title='Mitglieder der Nato in Europa (1949 bis heute)'
              source='Quelle: Nato'
            >
              <Key
                entries={[
                  {
                    type: 'shape',
                    label: 'vor dem Ende der Sowjetunion',
                    color: '#296A8D'
                  },
                  {
                    type: 'shape',
                    label: 'nach dem Ende der Sowjetunion',
                    color: '#9BC6DE'
                  }
                ]}
              />
              <SVG
                uniquifyIDs
                src={
                  isMobile
                    ? require('images/maps/Karten_nato_mobile.svg' as string)
                    : (require(`images/maps/Karten_nato_desktop.svg`) as string)
                }
                height='auto'
              />
            </Chart>
          <h4>Was ist die Nato-Osterweiterung?</h4>
          <p className='ta text'>
            m Kalten Krieg waren die mitteleuropäischen Satellitenstaaten der
            Sowjetunion Teil des Warschauer Pakts, also des sowjetischen
            Verteidigungsbündnisses. Dieses stand der Nato gegenüber, in der die
            USA die zentrale Rolle spielen. Mit dem Rückzug der Sowjetunion aus
            Osteuropa und ihrem Zusammenbruch 1991 erlangten die Länder
            Mitteleuropas ihre volle Souveränität zurück und machten schnell
            klar, dass sie in die Nato aufgenommen werden wollten. Russland sah
            die Erweiterung der Nato von Anfang kritisch und machte sich nach
            dem Kalten Krieg für eine neue Sicherheitsarchitektur in Europa
            stark, konnte sich aber nicht durchsetzen. Als Erstes wurden 1999
            Polen, Tschechien und Ungarn Nato-Mitglieder. 2004 folgte eine
            zweite Erweiterungsrunde, in der mit dem Baltikum erstmals einstige
            Sowjetrepubiken aufgenommen wurden. 2008 versicherte die Nato der
            Ukraine und Georgien, auch ihnen stünde der Weg offen in die
            Allianz, allerdings gibt es keinen konkreten Zeitplan dafür.
          </p>
          <div className='chartcontainer one'>
            <Chart
              title={
                <>
                  Mitglieder des Warschauer Pakts <span>(1955 &#8212; 1991)</span>
                </>
              }
              source='Quelle: Bundeszentrale für politische Bildung'
            >
              <Key
                entries={[
                  { type: 'shape', label: 'Sowjetunion', color: '#D3343F' },
                  { type: 'shape', label: 'Blockstaaten', color: '#E9999F' }
                ]}
              />
              <div>
                <SVG
                  uniquifyIDs
                  src={
                    isMobile
                      ? require('images/maps/Karten_warschauerpakt_mobile.svg' as string)
                      : (require(`images/maps/Karten_warschauerpakt_desktop.svg`) as string)
                  }
                  height='auto'
                />
              </div>
            </Chart>
          </div>
          <div className='chartcontainer one'>
            <Chart title='Aktuelle Situation für Russland ' source={<>&nbsp;</>}>
              <SVG
                uniquifyIDs
                src={
                  isMobile
                    ? require('images/maps/Karten_russland_heute_mobil.svg' as string)
                    : (require(`images/maps/Karten_russland_heute_desktop.svg`) as string)
                }
                height='auto'
              />
            </Chart>
          </div>
          <h4>Warum ist die Erweiterung ein Problem für Russland?</h4>
          <p className='ta text'>
            Moskau klagt, mit dem Vorstossen an die russische Grenze bedrohe die
            Nato die Sicherheitsinteressen Russlands. Man will unbedingt
            verhindern, dass sich die Allianz mit der Ukraine weiter bis nach
            Russland ausdehnt. Strategisch besonders wichtig ist für Moskau die
            Kontrolle im Schwarzen Meer, die mit einer Nato-Mitgliedschaft der
            Ukraine sehr viel schwieriger würde. Russland hat dort seine Flotte
            stationiert. Die Nato gesteht ein, dass es noch Jahre dauern könnte,
            bis die Ukraine aufgenommen wird – wenn überhaupt. Doch sie{' '}
            <Link href='726315654831' allowWordWrap>
              weigert sich strikt
            </Link>
            , ihr und anderen Ländern wie Finnland oder Schweden den Zugang auf
            Druck Moskaus zu verweigern: Jedes Land habe das Recht, selber über
            seine Zugehörigkeit zu einem Militärbündnis zu entscheiden.
          </p>
          <h4>
            Geht es nur um die Ukraine, oder mischt sich Russland auch anderswo
            ein?
          </h4>

          <p className='ta text'>
            Neben der Ukraine steht vor allem Georgien unter Druck, ebenfalls
            eine ehemalige Sowjetrepublik mit einst engen Beziehungen zu Moskau.
            Tiflis will sich wie die Ukraine näher an den Westen anlehnen und in
            die Nato aufgenommen werden.
          </p>
          <div className='chartcontainer one'>
            <Chart
              title={
                <>
                  Prorussische Separatistengebiete{' '}
                  <span>rund um das Schwarze Meer</span>
                </>
              }
            >
              <SVG
                uniquifyIDs
                src={
                  isMobile
                    ? require('images/maps/Karten_regionen_mobile.svg' as string)
                    : (require(`images/maps/Karten_regionen_desktop.svg`) as string)
                }
                height='auto'
              />
            </Chart>
          </div>
          <p className='ta text'>
            In den letzten Jahren ist dieser Wunsch zwar etwas in den
            Hintergrund gerückt, hatte zuvor aber zu massiven Verstimmungen,
            wirtschaftlichen Sanktionen und sogar einem kurzen militärischen
            Schlagabtausch geführt. Russland hat 2008 Truppen in das von
            Georgien abtrünnige Gebiet Südossetien geschickt, nachdem Tiflis
            versucht hatte, es mit Gewalt unter seine Kontrolle zu bringen. Im
            Anschluss hat Moskau beide georgischen Separatistengebiete,
            Südossetien und Abchasien, als unabhängig anerkannt. Russland gibt
            sich auch als politische und militärische Schutzmacht von
            Transnistrien, das zu Moldau gehört, seit 1990 aber faktisch
            unabhängig ist. Und auch im zwischen Armenien und Aserbeidschan
            umstrittenen{' '}
            <Link href='465907774734' allowWordWrap>
              Berg-Karabach sind russische Soldaten im Einsatz
            </Link>
            , die den dortigen Waffenstillstand überwachen.
          </p>
     
        </div>
   
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text', 'Zita Affentranger'],
          ['Grafik, Umsetzung', 'Sebastian Broschinski, Patrick Vögeli']
        ]}
      />
    </div>
  )
}
